import { render } from "./ReturnRequestIdDetailsRia.vue?vue&type=template&id=6d68a002&scoped=true"
import script from "./ReturnRequestIdDetailsRia.vue?vue&type=script&lang=js"
export * from "./ReturnRequestIdDetailsRia.vue?vue&type=script&lang=js"

import "./ReturnRequestIdDetailsRia.vue?vue&type=style&index=0&id=6d68a002&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d68a002"]])

export default __exports__